import React, { useEffect, useMemo } from 'react'
import { Card, Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { appUrl, apiResource } from '../../utils'
import ReactTableBootstrap from 'react-table-bootstrap'
import LoadingIcon from '../../components/loading/LoadingIcon'
import OficinaTabs from '../../components/oficina-tabs/OficinaTabs'
import { useGet } from '../../hooks/process-data'

export default function MisTicketsView() {
  const history = useHistory()
  const { sessionValidated, isCustomer, key_customer } = useSelector(
    state => state.session
  )

  const execute = !!(sessionValidated && isCustomer && key_customer)

  const { rows, isProcessing, setReload } = useGet({
    url: `/event/customer/tickets/${key_customer}`,
    execute
  })

  useEffect(() => {
    if (!sessionValidated || !isCustomer) {
      const redirect = encodeURIComponent(appUrl({ url: '/mis-tickets' }))
      history.push(
        appUrl({ url: '/cuenta/login?redirect=' + redirect })
      )
    } else {
      setReload(true)
    }
  }, [sessionValidated, isCustomer, history, setReload])

  const table = useMemo(() => {
    const head = [
      {
        name: 'date_pay',
        text: 'Fecha de compra',
        align: 'center'
      },
      {
        name: 'method_pay',
        text: 'Método de pago',
        align: 'center',
        render: r => (
          <span className="badge badge-pill bg-info text-uppercase">
            {r.method_pay}
          </span>
        )
      },
      {
        name: 'total_service_charge',
        text: 'Cargo por servicio (MXN)',
        align: 'center',
        render: r => {
          const v = parseFloat(r.total_service_charge || 0)
          return v.toFixed(2)
        }
      },
      {
        name: 'total_amount',
        text: 'Total (MXN)',
        align: 'center',
        render: r => {
          const v = parseFloat(r.total_amount || 0)
          return <strong>{v.toFixed(2)}</strong>
        }
      },
      {
        name: 'actions',
        text: <i className="fa fa-cog" />,
        align: 'center',
        render: r => {
          if (!r.final_pdf) return null
          const href = apiResource({ url: r.final_pdf })
          return (
            <a href={href} target="_blank" rel="noreferrer">
              <Button variant="danger">
                <i className="fa fa-file-pdf me-2 text-white" />
                <span className="text-white">Descargar PDF</span>
              </Button>
            </a>
          )
        }
      }
    ]

    return (
      <ReactTableBootstrap
        head={[head]}
        rows={rows}
        isProcessing={isProcessing}
        pageLength={10}
        orderDirection="desc"
        columnOrder="date_pay"
      />
    )
  }, [rows, isProcessing])

  const hasTickets = rows && rows.length > 0

  return (
    <>
      <div className="container py-4 py-lg-5">
        <OficinaTabs />
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-11 col-12">
            {/* Header de la sección */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
              <div>
                <h1 className="h4 mb-1">Mis tickets</h1>
                <p className="text-muted mb-0">
                  Consulta el historial de tus compras y descarga tus boletos
                  en cualquier momento.
                </p>
              </div>
            </div>

            <Card className="shadow-sm border-0">
              <Card.Body>
                {isProcessing && (
                  <div className="d-flex justify-content-center py-4">
                    <LoadingIcon />
                  </div>
                )}

                {!isProcessing && !hasTickets && (
                  <div className="text-center py-5">
                    <i className="fa fa-ticket-alt fa-3x text-muted mb-3" />
                    <h2 className="h5 mb-2">Todavía no tienes tickets</h2>
                    <p className="text-muted mb-4">
                      Cuando compres entradas, aparecerán aquí para que puedas
                      descargarlas o revisarlas fácilmente.
                    </p>
                    <Button
                      variant="primary"
                      onClick={() =>
                        history.push(appUrl({ url: '/' }))
                      }
                    >
                      Explorar eventos
                    </Button>
                  </div>
                )}

                {hasTickets && (
                  <>
                    {table}
                  </>
                )}
              </Card.Body>
            </Card>
          </div>
        </div>

        {isProcessing && hasTickets && (
          <div className="d-flex justify-content-center mt-3">
            <LoadingIcon />
          </div>
        )}
      </div>
    </>
  )
}
